export default __webpack_public_path__ + "static/media/security-code.c33e7757.svg";